import type { ReactNode } from 'react'

interface TimesheetToolbarProps {
  /** Navigeren: stepper, sprong naar nu, weergavekeuze. Omlijnde pillen en knoppen. */
  nav?: ReactNode
  /** Aflezen: welke periode en hoe die ervoor staat. Gedempte tekst en kale staafjes. */
  readout?: ReactNode
  /** Doen: weergave-opties en de acties op deze week. Rechts uitgelijnd. */
  actions?: ReactNode
}

/**
 * Elke urenbalk heeft dezelfde drie clusters op dezelfde plek. De ruimere afstand
 * tussen de clusters draagt de groepering: binnen een cluster staan de elementen
 * dicht op elkaar, ertussen valt een gat.
 */
export function TimesheetToolbar({ nav, readout, actions }: TimesheetToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
      {nav ? <div className="flex flex-wrap items-center gap-2">{nav}</div> : null}
      {readout ? <div className="flex flex-wrap items-center gap-3">{readout}</div> : null}
      {actions ? <div className="ml-auto flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  )
}
